import { FULL_SCREEN_OFF, FULL_SCREEN_ON, GET_SUBJECT_WHITEBOARD, UPLOAD_RECORDING_FAIL, UPLOAD_RECORDING_START, UPLOAD_RECORDING_SUCCESS } from "../Types/types";

let intialState = {
    isFullScreen: false
}

export default function whiteboardReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case FULL_SCREEN_ON:
            stateCopy.isFullScreen = true;
            return stateCopy;
        case FULL_SCREEN_OFF:
            stateCopy.isFullScreen = false;
            return stateCopy;
        case GET_SUBJECT_WHITEBOARD:
            stateCopy.subjectWhiteboard = action.payload;
            return stateCopy;
        case UPLOAD_RECORDING_START:
            stateCopy.isUploading = true;
            return stateCopy;
        case UPLOAD_RECORDING_SUCCESS:
            stateCopy.isUploading = false;
            return stateCopy;
        case UPLOAD_RECORDING_FAIL:
            stateCopy.isUploading = false;
            return stateCopy;
        default:
            return stateCopy;
    }
}
